<template>
  <div class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toolbar class="p-mb-4">
          <template v-slot:left>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-7">
                <label for="pessoa">Informe a Pessoa</label>
                <Dropdown
                  v-model="selectedPessoa"
                  :options="pessoas"
                  :filter="true"
                  :showClear="true"
                  optionValue="id"
                  optionLabel="nome"
                  placeholder="Selecione um Servidor"
                  class="p-mr-2 p-mb-2"
                />
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="data">Informe o Mês</label>
                <Calendar
                  id="monthpicker"
                  v-model="data"
                  view="month"
                  dateFormat="mm/yy"
                  placeholder="mm/yyyy"
                  :yearNavigator="true"
                  yearRange="2000:2030"
                />
              </div>

              <div class="p-field p-col-12 p-md-1">
                <br />
                <Button
                  icon="pi pi-search"
                  style="margin-top: 7px"
                  @click="listarRegistroBatida()"
                />
              </div>
            </div>
          </template>
          <template v-slot:right>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help p-mb-2"
              :disabled="!registros"
              @click="exportCSV($event)"
          /></template>
        </Toolbar>

        <div class="p-grid crud-demo">
          <div class="p-col-12 p-md-12">
            <DataTable
              ref="dt"
              :value="registros"
              class="p-datatable-sm p-datatable-striped"
              v-if="apresentar"
              dataKey="0"
            >
              <template #header>
                <div class="p-fluid p-formgrid p-grid" id="dadosPonto">
                  <div class="p-field p-col-12 p-md-12">
                    <div class="p-fluid p-formgrid p-grid">
                      <div class="p-col-12 p-md-2">
                        <div class="p-d-flex p-ai-center p-jc-center ctisDiv">
                          <img
                            src="assets/layout/images/sespa.png"
                            alt="SESPA"
                            width="230"
                            class="ctis"
                            style="margin-top: 45px"
                          />
                        </div>
                      </div>
                      <div class="p-col-12 p-md-9" v-if="pessoa[0]">
                        <label>Nome: {{ pessoa[0][0] }}</label
                        ><br />
                        <label>Matricula: {{ pessoa[0][1] }}</label
                        ><br />
                        <label v-if="pessoa[0][3]"
                          >Cargo: {{ pessoa[0][3] }}</label
                        >
                        <label v-else>Cargo: SEM CARGO</label><br />
                        
                        <label v-if="pessoa[0][4]"
                          >Função: {{ pessoa[0][4] }}.</label
                        >
                        <label v-else>Função: SEM FUNÇÃO</label> <br />
                        <label>Atuação: {{ pessoa[0][5] }}</label
                        ><br />
                        <label>Situação: {{ pessoa[0][2] }}</label
                        ><br />
                        <label>Horario: {{ pessoa[0][6] }}</label
                        ><br />
                        <label for="mes_ano"
                          >Registro de Batidas - {{ mesAno }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template #empty>
                <div class="p-text-center">Nenhum resultado encontrado...</div>
              </template>
              <Column header="Dia/Data" :sortable="true">
                <template #body="slotProps">
                  <span class="p-column-title">Dia/Data</span>
                  {{ slotProps.data[0] }} - <small class="product-badge">{{ formatarDiaSemana(slotProps.data[0]) }}</small>
                </template>
              </Column>

              <Column header="Batidas" :sortable="true">
                <template #body="slotProps">
                  <span class="p-column-title">Batidas</span>
                  {{ slotProps.data[1] }}
                </template>
              </Column>
              <Column header="Observações" :sortable="true">
                <template #body="slotProps">
                  <span class="p-column-title">Observações</span>
                  {{ slotProps.data[2] }}
                </template>
              </Column>
              <Column header="Inconsistência" :sortable="true">
                <template #body="slotProps">
                  <span class="p-column-title">Inconsistência</span>
                  <span
                    v-if="
                      verificarInconsistencia(slotProps.data[2]) ===
                      'SEM INCONSISTÊNCIA.'
                    "
                    class="product-badge-su"
                  >
                    {{ verificarInconsistencia(slotProps.data[2]) }}</span
                  >

                  <span v-else class="product-badge-error">
                    {{ verificarInconsistencia(slotProps.data[2]) }}</span
                  >
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import AuthService from "@/service/Auth/AuthService";

import PessoaService from "@/service/Pessoa/PessoaService";
import BatidaService from "@/service/Batida/BatidaService";

export default {
  data() {
    return {
      pessoa: {
        nome: null,
        mf: null,
        situacao: null,
        cargo: null,
        funcao: null,
        atuacao: null,
        horario: null,
      },
      pessoas: null,
      selectedPessoa: null,
      data: null,
      mesAno: null,
      registros: null,
      apresentar: false,
    };
  },
  authService: null,
  pessoaService: null,
  batidaService: null,
  created() {
    this.authService = new AuthService();
    this.pessoaService = new PessoaService();
    this.batidaService = new BatidaService();
  },
  mounted() {
    this.listPessoas();
  },
  methods: {
    formatarHora(date) {
      if (date) {
        return Moment(date).utc().format("H:mm:ss");
      }
      return;
    },
    formatarDiaSemana(data) {
      let d = new Date(data.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
      var semana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
      return semana[d.getDay()];
    },
    listPessoas() {
      this.pessoaService.listar().then((data) => {
        this.pessoas = data;
      });
    },
    listOcorrenciasPessoa(codigo) {
      this.pessoaService.listarOcorrencias(codigo).then((data) => {
        this.pessoa = data;        
      });
    },
    listarRegistroBatida() {
      if (this.selectedPessoa !== null && this.data !== null) {
        let mes = this.data.getMonth() + 1;
        let ano = this.data.getFullYear();
        this.batidaService
          .listarServidorMensal(this.selectedPessoa, ano, mes)
          .then((data) => {
            if (data.length == 0) {
              this.apresentar = false;
              alert(
                "Não foram encontrado registros de batidas para data " +
                  Moment(this.data).utc().format("DD/MM/YYYY") +
                  "."
              );
            } else {
              this.registros = data;
              this.mesAno =
                "" +
                this.data.toLocaleString("default", { month: "long" }) +
                "/" +
                ano;
              this.listOcorrenciasPessoa(this.selectedPessoa);
              this.apresentar = true;
            }
          });
      } else {
        alert("Campo de pessoa e mês são obrigatórios.");
      }
    },
    verificarInconsistencia(dados) {
      if (dados.indexOf("  ENTRADA  |  ENTRADA  ") != -1) {
        return "DOIS O MAIS REGISTROS DE ENTRADAS.";
      } else if (dados.indexOf("  SAÍDA  |  SAÍDA") != -1) {
        return "DOIS OU MAIS REGISTROS DE SAÍDAS.";
      } else if (dados === "SAÍDA") {
        return "SOMENTE REGISTRO DE SAÍDA.";
      } else if (dados === "ENTRADA") {
        return "SOMENTE REGISTRO DE ENTRADA.";
      } else {
        return "SEM INCONSISTÊNCIA.";
      }
    },
    exportCSV() {
      this.$refs.dt.exportCSV(this.registros);
    },
  },
};
</script>

<style scoped lang="scss">
.img-fluid {
  max-width: 100%;
  height: auto;
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.visitante-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.p-dialog .visitante-image {
  width: 150px;
  margin: 0 auto 2rem auto;
  display: block;
}
.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.p-datatable-sm .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  ::v-deep(.p-datatable) {
    &.p-datatable-sm {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;
        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }
        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: left;
        }
        .p-rating {
          display: inline-block;
        }
      }
    }
  }
}
#dadosPonto {
  font-size: 12.5px;
}
.product-badge-su {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background: #c8e6c9;
  color: #256029;
}

.product-badge-error {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background: #c8e6c9;
  color: #256029;
  background: #ffcdd2;
  color: #c63737;
}
.product-badge {
  border-radius: 2px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
</style>